module.exports = __webpack_public_path__ + "static/media/YF23_3.d8777f9e.jpg";